import Receipts from '../../../../../api/Sales/Receipts'
import CustomSpin from '../../../../../elements/CustomSpin'
import useFetchSelectUrl from '../../../../../elements/Hooks/useFetchSelectUrl'
import { get, isEmpty, pick } from 'lodash'
import { defaultFormItemLayout, threeFormItemLayout, TwoPartThreeColFormItemLayout } from '../../../../../modules/FormItems'
import React, { useState } from 'react'
import { Button, Col, Form, Input, message, Popconfirm, Row } from 'antd'
import { checkForm, dateFormat, dateVal, moneyInline, numVal, sessionItemByCode, strVal } from '../../../../../modules/Utils'
import IconText from '../../../../../elements/IconText'

import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import withData from '../../../../../elements/Select/withData'
import withSort from '../../../../../elements/HOC/withSort'
import CustomSelect from '../../../../../elements/Select/CustomSelect'

const { TextArea } = Input

const ReceiptsAPI = new Receipts()

const ReceiptTypeSelect = compose(
  withData({
    data: [
      { key: 'deposit', value: 'Deposit' },
      { key: 'invoice', value: 'Invoiced Services' },
    ],
  }),
  withSort,
)(CustomSelect)

function Overview (props) {
  const { receipt, fetching, formRef, fetch } = props
  const { getFieldDecorator } = props.form
  const [submitting, setSubmitting] = useState(false)

  async function update () {
    const updatedObject = await checkForm(formRef)
    setSubmitting(true)
    try {
      await ReceiptsAPI.update({
        ...updatedObject,
        ...pick(receipt, ['_id', '_key', '_rev']),
      })
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  async function remove () {
    setSubmitting(true)
    try {
      await ReceiptsAPI.remove({ ...pick(receipt, ['_id', '_key', '_rev']) })
      props.history.replace({
        pathname: `/clients/payments/#receipts`,
      })
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  const client = get(receipt, 'client.member._id', '').replace('members/', '')
  const [PayableRepSelect] = useFetchSelectUrl(
    {
      name: 'vendorRep',
      url: `members/${client}/representatives`,
      cache: true,
      forceFetch: true,
    },
    [client],
    isEmpty(client),
  )

  return (
    <CustomSpin spinning={fetching || submitting}>
      <Row>
        {receipt.status === 'Draft' && (
          <Col span={4} offset={20} style={{ marginBottom: 15 }}>
            <Button loading={submitting} type="primary" onClick={update}>
              Update
            </Button>
            <Popconfirm
              title="Are you sure remove this Receipt?"
              onConfirm={remove}
              okText="Yes"
              cancelText="No">
              <Button type="danger" loading={submitting} style={{ marginLeft: 8 }}>
                Remove
              </Button>
            </Popconfirm>
          </Col>
        )}
      </Row>
      <Form>
        <Row>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Company'}>
              {getFieldDecorator('company.fn', {
                initialValue: get(receipt, 'company.fn'),
              })(<Input disabled={true}/>)}
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item {...TwoPartThreeColFormItemLayout} label={'Address'}>
              {getFieldDecorator('company.address.label', {
                initialValue: strVal(receipt, 'company.address.label'),
              })(<TextArea disabled={true} rows={4}/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <span>Receipt Date: {dateFormat(dateVal(receipt, 'date'))}</span>
            {/*<Form.Item {...threeFormItemLayout} label={'Receipt Date'}>
              {getFieldDecorator('date', {
                initialValue: dateFormat(dateVal(receipt, 'date')),
              })(<Input disabled={true}/>)}
            </Form.Item>*/}
          </Col>
          <Col span={8}>
            <span>Receipt Amount: {strVal(receipt, "transaction.currency")} {moneyInline(numVal(receipt, 'receiptsTotal'))}</span>
            {/*<Form.Item {...threeFormItemLayout} label={'Receipt Amount'}>
              {getFieldDecorator('receiptsTotal', {
                initialValue: moneyInline(
                  numVal(receipt, 'receiptsTotal'),
                  strVal(receipt, 'transaction.currency'),
                ),
              })(<Input disabled={true} />)}
            </Form.Item>*/}
          </Col>
          <Col span={8}>
            <span>Receipt Currency: {sessionItemByCode(
              'general_currency_dropdown',
              strVal(receipt, 'transaction.currency'),)} - {strVal(receipt, 'transaction.currency')}</span>
            {/*<Form.Item {...threeFormItemLayout} label={'Currency'}>
              {getFieldDecorator('transaction.currency', {
                initialValue: `${sessionItemByCode(
                  'general_currency_dropdown',
                  strVal(receipt, 'transaction.currency'),
                )} - ${strVal(receipt, 'transaction.currency')}`,
              })(<Input disabled={true}/>)}
            </Form.Item>*/}
          </Col>
        </Row>
        <Row>
          <h4 style={{ paddingTop: 10 }}>Payment Details</h4>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Transaction Ref'}>
              {getFieldDecorator('transaction.remittance.ref', {
                initialValue: strVal(receipt, 'transaction.remittance.ref'),
              })(<TextArea rows={4}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Payment Description'}>
              {getFieldDecorator('transaction.notes', {
                initialValue: strVal(receipt, 'transaction.notes'),
              })(<TextArea rows={4}/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <span>Transaction Date: {dateFormat(dateVal(receipt, 'transaction.date'))}</span>
            {/*<Form.Item {...threeFormItemLayout} label={'Transaction Date'}>
              {getFieldDecorator('transaction.date', {
                initialValue: dateFormat(dateVal(receipt, 'transaction.date')),
              })(<Input disabled={true}/>)}
            </Form.Item>*/}
          </Col>
          <Col span={8}>
            <span>Transaction Amount: {strVal(receipt, "transaction.currency")} {moneyInline(numVal(receipt, 'transaction.amount'))}</span>
            {/*<Form.Item {...threeFormItemLayout} label={'Transaction Amount'}>
              {getFieldDecorator('transaction.amount', {
                initialValue: moneyInline(
                  numVal(receipt, 'transaction.amount'),
                  strVal(receipt, 'transaction.currency'),
                ),
              })(<Input disabled={true}/>)}
            </Form.Item>*/}
          </Col>
          <Col span={8}>
            <span>Payment Currency: {sessionItemByCode(
            'general_currency_dropdown',
            strVal(receipt, 'transaction.currency'),)} - {strVal(receipt, 'transaction.currency')}</span>
            {/*<Form.Item {...threeFormItemLayout} label={'CPO Currency'}>
              {getFieldDecorator('transaction.currency', {
                initialValue: `${sessionItemByCode(
                  'general_currency_dropdown',
                  strVal(receipt, 'transaction.currency'),
                )} - ${strVal(receipt, 'transaction.currency')}`,
              })(<Input disabled={true}/>)}
            </Form.Item>*/}
          </Col>
          <Col span={8}>
            <span>Company: {get(receipt, 'company.fn')}</span>
            {/*<Form.Item {...threeFormItemLayout} label={'Company'}>
              {getFieldDecorator('company.fn', {
                initialValue: get(receipt, 'company.fn'),
              })(<Input disabled={true}/>)}
            </Form.Item>*/}
          </Col>
          <Col span={8}>
            <span>Bank: {strVal(receipt, 'transaction.bank.title')}</span>
            {/*<Form.Item {...threeFormItemLayout} label={'Bank'}>
              {getFieldDecorator('transaction.bank.title', {
                initialValue: strVal(receipt, 'transaction.bank.title'),
              })(<Input disabled={true}/>)}
            </Form.Item>*/}
          </Col>
          <Col span={8}>
            <span>Bank Code: {strVal(receipt, 'transaction.bank.code')}</span>
            {/*<Form.Item {...threeFormItemLayout} label={'Bank Code'}>
              {getFieldDecorator('transaction.bank.code', {
                initialValue: strVal(receipt, 'transaction.bank.code'),
              })(<Input disabled={true}/>)}
            </Form.Item>*/}
          </Col>
        </Row>

        <Row style={{ marginBottom: 10 }}>
          <h4 style={{ paddingTop: 10 }}>Client details</h4>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Name'}>
              <span style={{ 'white-space': 'pre-line' }}>
                <a
                  href={`#/clients/${strVal(receipt, 'client.owner').replace('members/', '')}/`}
                  target={'_blank'}>
                  <IconText
                    type={'arrows-alt'}
                    text={strVal(receipt, 'client.fn')}
                    position={'left'}
                  />
                </a>
              </span>
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item {...TwoPartThreeColFormItemLayout} label={'Address'}>
              {getFieldDecorator('client.address.label', {
                initialValue: strVal(receipt, 'client.address.label'),
              })(<TextArea disabled={true} rows={4}/>)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Tax ID'}>
              {getFieldDecorator('client.taxRegistration', {
                initialValue: strVal(receipt, 'client.taxRegistration'),
              })(<Input style={{width:'85%'}}/>)}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Invoicing Contact'}>
              {' '}
              {getFieldDecorator('payableRep._id', {
                initialValue: strVal(receipt, 'payableRep._id'),
              })(<PayableRepSelect style={{width:'90%'}} keyAtr={'_id'} valueAtr={'name'}/>)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label="Notify Additional">
              {getFieldDecorator('additionalRep._id', {
                initialValue: get(receipt, 'additionalRep._id'),
              })(<Input placestyle={{ width: '100%' }}/>)}
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ marginBottom: 10 }}>
          <h4>Receipt Document Mgmt</h4>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label="PDF Receipt Type">
              {getFieldDecorator('receiptType', {
                initialValue: get(receipt, 'receiptType'),
              })(<ReceiptTypeSelect placeholder={'PDF Receipt Type'}/>)}
            </Form.Item>
          </Col>
        </Row>

      </Form>
    </CustomSpin>
  )
}

Overview.propTypes = {}
Overview.defaultProps = {}

export default Form.create()(withRouter(Overview))
